"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const e=require("../../../node_modules/graphql-tag/lib/index.js").gql`
  query getDesignService($designId: String!) {
    getDesignV2(designId: $designId) {
      designId
      design {
        modelFinderSessionId
        dxClientId
        feedbackSubmitted
        status
        content {
          salesModelId
          basePrice
          options {
            configuratorOptionId
            selectionId
            selection {
              id
              price
            }
          }
        }
        zipCode
        productSeries
      }
    }
  }
`;exports.getDesign=e;
//# sourceMappingURL=queries.js.map
